"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.finaliseEntitySchema = void 0;
var lodash_1 = require("lodash");
var entity_banner_query_1 = require("./entity-banner-query");
var entity_comments_query_1 = require("./entity-comments-query");
var entity_create_mutation_1 = require("./entity-create-mutation");
var entity_connections_query_1 = require("./entity-connections-query");
var entity_delete_mutation_1 = require("./entity-delete-mutation");
var entity_details_query_1 = require("./entity-details-query");
var entity_form_query_1 = require("./entity-form-query");
var entity_graph_query_1 = require("./entity-graph-query");
var entity_list_query_1 = require("./entity-list-query");
var entity_map_query_1 = require("./entity-map-query");
var entity_named_query_1 = require("./entity-named-query");
var entity_network_query_1 = require("./entity-network-query");
var entity_platform_activity_query_1 = require("./entity-platform-activity-query");
var entity_select_query_1 = require("./entity-select-query");
var entity_update_query_1 = require("./entity-update-query");
var entity_update_mutation_1 = require("./entity-update-mutation");
var sprintf_js_1 = require("sprintf-js");
var graphql_1 = require("./graphql");
var entity_export_query_1 = require("./entity-export-query");
var fieldOutput = function (field, fieldName, entities, isUpdate) {
  if (isUpdate === void 0) {
    isUpdate = false;
  }
  return "".concat(fieldName).concat(field.aliasOf ? ":".concat(field.aliasOf) : '').concat(isUpdate && field.updateArgs ? "(".concat(field.updateArgs, ")") : '');
};
var entityValueFields = function (field, fieldName, entities) {
  var linkedDefn = entities[field.entityTypeName];
  var useOpenGraph = linkedDefn && linkedDefn.useOpenGraph;
  return useOpenGraph ? graphql_1.ENTITY_VALUE_FIELDS : graphql_1.ENTITY_CORE_VALUE_FIELDS;
};
var tableFieldsForDefinition = function (defn, entities, isUpdate) {
  if (isUpdate === void 0) {
    isUpdate = false;
  }
  var formFields = defn.form && defn.form.fields || {};
  var useOpenGraph = defn.useOpenGraph;
  var tableFieldOutput = function (field, fieldName) {
    return formFields[fieldName] ? fieldOutput(formFields[fieldName], fieldName, entities, isUpdate) : fieldName;
  };
  var tableEntityValueFields = function (field, fieldName) {
    return formFields[fieldName] ? entityValueFields(formFields[fieldName], fieldName, entities) : '';
  };
  return "\n      ".concat(useOpenGraph ? graphql_1.ENTITY_VALUE_FIELDS : graphql_1.ENTITY_CORE_VALUE_FIELDS, "\n      ").concat((0, lodash_1.map)(defn.table.scalarFields, function (field, fieldName) {
    return tableFieldOutput(field, fieldName);
  }).join(" "), "\n      ").concat((0, lodash_1.map)(defn.table.personFields, function (field, fieldName) {
    return "".concat(tableFieldOutput(field, fieldName), " { ").concat(graphql_1.CREATOR_FIELDS, " }");
  }).join("\n"), "\n      ").concat((0, lodash_1.map)(defn.table.linkedFields, function (field, fieldName) {
    return "".concat(tableFieldOutput(field, fieldName), " { ").concat(tableEntityValueFields(field, fieldName), " }");
  }).join("\n"), "\n      ").concat((0, lodash_1.map)(defn.table.contentNodeFields, function (field, fieldName) {
    return "".concat(tableFieldOutput(field, fieldName), " { ").concat(graphql_1.CONTENT_NODE_UPDATE_FIELDS, " }");
  }).join("\n"), "\n      ").concat((0, lodash_1.map)(defn.table.imageFields, function (field, fieldName) {
    return "".concat(tableFieldOutput(field, fieldName), " { ").concat(graphql_1.IMAGE_UPDATE_FIELDS, " }");
  }).join("\n"), "\n      ").concat((0, lodash_1.map)(defn.table.fileFields, function (field, fieldName) {
    return "".concat(tableFieldOutput(field, fieldName), " { ").concat(graphql_1.FILE_UPDATE_FIELDS, " }");
  }).join("\n"), "\n    ");
};
/**
 * Defines entity queries for definitions. We need to do this in a second pass so that all entities are
 * defined and enities can then infer field specs from related entities for linked fields.
 * @param entities
 * @returns
 */
var finaliseEntitySchema = function (entities) {
  return (0, lodash_1.mapValues)(entities, function (defn) {
    var ret = __assign(__assign({}, defn), {
      update: __assign(__assign({}, defn.update || {}), {
        queryFields: "\n            ".concat(defn.update.queryFields || "", "\n            ").concat((0, lodash_1.map)(defn.scalarFields, function (field, fieldName) {
          return fieldOutput(field, fieldName, entities, true);
        }).join(" "), "\n            ").concat((0, lodash_1.map)((0, lodash_1.pickBy)(defn.linkedFields, function (field) {
          return !field.specOnly;
        }), function (field, fieldName) {
          return "".concat(fieldOutput(field, fieldName, entities, true), " { ").concat(entityValueFields(field, fieldName, entities), " }");
        }).join("\n"), "\n            ").concat((0, lodash_1.map)(defn.entityReferenceFields, function (field, fieldName) {
          return "".concat(fieldOutput(field, fieldName, entities, true), " { id entity { ").concat(graphql_1.ENTITY_VALUE_FIELDS, " } }");
        }).join("\n"), "\n            ").concat((0, lodash_1.map)((0, lodash_1.pickBy)(defn.linkedTableFields, function (field) {
          return !field.specOnly;
        }), function (field, fieldName) {
          return "".concat(fieldOutput(field, fieldName, entities, true), " {\n              id\n              ").concat(entities[field.entityTypeName] ? tableFieldsForDefinition(entities[field.entityTypeName], entities) : '', "\n            }");
        }).join("\n"), "\n            ").concat((0, lodash_1.map)(defn.contentNodeFields, function (field, fieldName) {
          return "".concat(fieldOutput(field, fieldName, entities, true), " { ").concat(graphql_1.CONTENT_NODE_UPDATE_FIELDS, " }");
        }).join("\n"), "\n            ").concat((0, lodash_1.map)(defn.imageFields, function (field, fieldName) {
          return "".concat(fieldOutput(field, fieldName, entities, true), " { ").concat(graphql_1.IMAGE_UPDATE_FIELDS, " }");
        }).join("\n"), "\n            ").concat((0, lodash_1.map)(defn.fileFields, function (field, fieldName) {
          return "".concat(fieldOutput(field, fieldName, entities, true), " { ").concat(graphql_1.FILE_UPDATE_FIELDS, " }");
        }).join("\n"), "\n          ")
      }),
      list: __assign(__assign({}, defn.list || {}), {
        // todo - patch this for grid (card) views too when using grid variant
        queryFields: "\n            ".concat(defn.list.queryFields || "", "\n            ").concat(defn.list.resultsVariant === 'table' ? tableFieldsForDefinition(defn, entities) : '', "\n          ")
      }),
      export: __assign(__assign({}, defn.export || {}), {
        queryFields: "\n            ".concat(defn.export.queryFields || "", "\n          ")
      }),
      details: __assign(__assign({}, defn.details || {}), {
        queryFields: "\n            ".concat(defn.details.queryFields || "", "\n            ").concat((0, lodash_1.map)(defn.scalarFields, function (field, fieldName) {
          return fieldOutput(field, fieldName, entities);
        }).join(" "), "\n            ").concat((0, lodash_1.map)((0, lodash_1.pickBy)(defn.linkedFields, function (field) {
          return !field.specOnly;
        }), function (field, fieldName) {
          return "".concat(fieldOutput(field, fieldName, entities, true), " { ").concat(entityValueFields(field, fieldName, entities), " }");
        }).join("\n"), "\n            ").concat((0, lodash_1.map)(defn.entityReferenceFields, function (field, fieldName) {
          return "".concat(fieldOutput(field, fieldName, entities), " { id entity { ").concat(graphql_1.ENTITY_VALUE_FIELDS, " } }");
        }).join("\n"), "\n            ").concat((0, lodash_1.map)((0, lodash_1.pickBy)(defn.linkedTableFields, function (field) {
          return !field.specOnly;
        }), function (field, fieldName) {
          return "".concat(fieldOutput(field, fieldName, entities, true), " { ").concat(entityValueFields(field, fieldName, entities), " }");
        }).join("\n"), "\n            ").concat((0, lodash_1.map)(defn.contentNodeFields, function (field, fieldName) {
          return "".concat(fieldOutput(field, fieldName, entities), " { ").concat(graphql_1.CONTENT_NODE_UPDATE_FIELDS, " }");
        }).join("\n"), "\n            ").concat((0, lodash_1.map)(defn.imageFields, function (field, fieldName) {
          return "".concat(fieldOutput(field, fieldName, entities, true), " { ").concat(graphql_1.IMAGE_UPDATE_FIELDS, " }");
        }).join("\n"), "\n            ").concat((0, lodash_1.map)(defn.fileFields, function (field, fieldName) {
          return "".concat(fieldOutput(field, fieldName, entities, true), " { ").concat(graphql_1.FILE_UPDATE_FIELDS, " }");
        }).join("\n"), "\n          ")
      })
    });
    // @ts-ignore
    return __assign(__assign({}, ret), {
      update: __assign(__assign({}, ret.update), {
        query: (0, entity_update_query_1.entityUpdateQuery)(ret, {
          entities: entities
        }),
        mutation: (0, entity_update_mutation_1.entityUpdateMutation)(ret, {
          entities: entities
        })
      }),
      select: __assign(__assign({}, ret.select), {
        query: (0, entity_select_query_1.entitySelectQuery)(ret, {
          entities: entities
        }),
        loadOptionsPaginate: ret.select.loadOptionsPaginate || function (context) {
          return (0, lodash_1.debounce)(function (inputValue, prevOptions) {
            return __awaiter(void 0, void 0, void 0, function () {
              var loadOptionsFilter, filter, data, listResults, _a, results, meta, options, allOptions;
              return __generator(this, function (_b) {
                switch (_b.label) {
                  case 0:
                    loadOptionsFilter = context.loadOptionsFilter || ret.select.loadOptionsFilter;
                    filter = loadOptionsFilter(inputValue);
                    return [4 /*yield*/, context.client.query({
                      query: ret.select.query,
                      variables: {
                        limit: 54,
                        skip: prevOptions.length,
                        filter: filter
                      }
                    })];
                  case 1:
                    data = _b.sent().data;
                    listResults = data[ret.select.queryName] || {
                      results: [],
                      meta: {
                        count: 0,
                        total: 0
                      }
                    };
                    _a = listResults.results, results = _a === void 0 ? [] : _a, meta = listResults.meta;
                    options = results.map(function (entity) {
                      return ret.select.transform(entity, context);
                    }) || [];
                    allOptions = __spreadArray(__spreadArray([], __read(prevOptions || []), false), __read(results.map(function (entity) {
                      return ret.select.transform(entity, context);
                    })), false);
                    return [2 /*return*/, {
                      hasMore: allOptions.length < meta.total,
                      options: options
                    }];
                }
              });
            });
          }, ret.select.debounceInterval);
        },
        loadOptions: ret.select.loadOptions || function (context) {
          return (0, lodash_1.debounce)(function (inputValue) {
            return __awaiter(void 0, void 0, void 0, function () {
              var filter, data, listResults, results, mapped;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    filter = ret.select.loadOptionsFilter(inputValue);
                    return [4 /*yield*/, context.client.query({
                      query: ret.select.query,
                      variables: {
                        limit: 0,
                        skip: 0,
                        filter: filter
                      }
                    })];
                  case 1:
                    data = _a.sent().data;
                    listResults = data[ret.select.queryName] || {
                      results: []
                    };
                    results = listResults.results;
                    mapped = results.map(function (entity) {
                      return ret.select.transform(entity, context);
                    });
                    return [2 /*return*/, mapped];
                }
              });
            });
          }, ret.select.debounceInterval);
        }
      }),
      list: __assign(__assign({}, ret.list), {
        query: (0, entity_list_query_1.entityListQuery)(ret, {
          entities: entities
        }),
        banner: __assign(__assign({}, ret.list.banner || {}), {
          query: (0, entity_banner_query_1.entityBannerQuery)(ret, {
            entities: entities
          })
        })
      }),
      commentsQuery: ret.useConversation && (0, entity_comments_query_1.entityCommentsQuery)(ret, {
        entities: entities
      }),
      namedQuery: (0, entity_named_query_1.entityNamedQuery)(ret, {
        entities: entities
      }),
      form: __assign(__assign({}, ret.form), {
        query: ret.form.query || ret.form.queryFields && (0, entity_form_query_1.entityFormQuery)(ret, {
          entities: entities
        })
      }),
      export: __assign(__assign({}, ret.export), {
        query: ret.export.query || (0, entity_export_query_1.entityExportQuery)(ret, {
          entities: entities
        })
      }),
      delete: __assign(__assign({}, ret.delete), {
        mutation: (0, entity_delete_mutation_1.entityDeleteMutation)(ret)
      }),
      details: __assign(__assign({}, ret.details), {
        query: ret.details.query || (0, entity_details_query_1.entityDetailsQuery)(ret, {
          entities: entities
        }),
        children: function (_a) {
          var t = _a.t,
            entities = _a.entities,
            icons = _a.icons,
            definition = _a.definition,
            applicationOptions = _a.applicationOptions;
          var detailsChildren = (0, lodash_1.filter)(ret.details.children && ret.details.children({
            entities: entities,
            t: t,
            icons: icons,
            definition: definition,
            applicationOptions: applicationOptions
          }) || []);
          // add an activity feed tab, if necessary
          if (definition.platformActivity.tab === 'own') {
            detailsChildren.unshift({
              type: 'platform-activity',
              label: (0, sprintf_js_1.sprintf)('%s Feed', definition.label),
              path: 'feed'
            });
          }
          return (0, lodash_1.filter)(detailsChildren.map(function (child) {
            var entityTypeName = child.entityTypeName,
              junctionEntityTypeName = child.junctionEntityTypeName,
              _a = child.type,
              type = _a === void 0 ? 'list' : _a,
              fieldName = child.fieldName;
            if (entityTypeName && !entities[entityTypeName]) {
              return null;
            }
            var showDetailsTab = !!child.showDetailsTab;
            var childEntityDefinition = entities[junctionEntityTypeName || entityTypeName];
            var actualChildEntityDefinition = entities[entityTypeName];
            var label = child.label || childEntityDefinition && childEntityDefinition.pluralLabel;
            var path = child.path || (0, lodash_1.includes)(['list', 'linkedMultiple'], type) && actualChildEntityDefinition && actualChildEntityDefinition.pluralSlug || (0, lodash_1.includes)(['linked'], type) && child.label && (0, lodash_1.kebabCase)(child.label) || (0, lodash_1.kebabCase)(fieldName);
            var showCountLabel = child.showCountLabel === undefined ? true : child.showCountLabel;
            var countFieldName = child.countFieldName || (fieldName === 'parent' ? 'children' : childEntityDefinition && childEntityDefinition.leadingPluralTypeName);
            // if the type is a 'linked' type, we show the details layout for that item
            return __assign(__assign({
              component: child.component || ret.components.details,
              breadcrumbLabel: label,
              showDetailsTab: showDetailsTab,
              isAvailable: child.isAvailable || function () {
                return true;
              },
              // if not provided, child queries and component are the same as the main detail route
              query: (0, entity_details_query_1.entityDetailsQuery)(ret, {
                entities: entities,
                queryFields: child.queryFields
              }),
              showCountLabel: showCountLabel
            }, child), {
              label: label,
              countFieldName: countFieldName,
              path: path
            });
          }));
        }
      }),
      graph: __assign(__assign({}, ret.graph || {}), {
        query: ret.graph.query || (0, entity_graph_query_1.entityGraphQuery)(ret, {
          entities: entities
        })
      }),
      connections: __assign(__assign({}, ret.connections || {}), {
        query: ret.connections.query || (0, entity_connections_query_1.entityConnectionsQuery)(ret, {
          entities: entities
        })
      }),
      platformActivity: __assign(__assign({}, ret.platformActivity || {}), {
        query: (0, entity_platform_activity_query_1.entityPlatformActivityQuery)(ret, {
          entities: entities
        })
      }),
      network: __assign(__assign({}, ret.network || {}), {
        query: ret.network.query || (0, entity_network_query_1.entityNetworkQuery)(ret, {
          entities: entities
        })
      }),
      map: __assign(__assign({}, ret.map || {}), {
        query: ret.map.query || (0, entity_map_query_1.entityMapQuery)(ret, {
          entities: entities
        })
      }),
      create: __assign(__assign({}, ret.create || {}), {
        mutation: (0, entity_create_mutation_1.entityCreateMutation)(ret, {
          entities: entities
        })
      })
    });
  });
};
exports.finaliseEntitySchema = finaliseEntitySchema;